import React from 'react';
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

import { FormInput, FormInputProps } from '@occc-app/Offer/components/FormInput';
import { AutocompleteOption, AutocompleteProps } from '@occc-app/design-system';
import { Autocomplete } from '@occc/ui-design-system';

import {
  autocompleteLengthValidation,
  withAutocompleteValueValidation,
} from '../../validatableComponent';
import { actions, Segment, State } from '../redux';

type InAnySegmentsValidateWith = Pick<State['inAnySegments'], 'segments'>;

type Actions = typeof actions;
type ComponentState = State['inAnySegments'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  audienceConfigurationUpdate: Actions['audienceConfigurationUpdate'];
  availableSegments?: Segment[];
  editMode?: boolean;
  fieldDisabled: (field: Fields) => boolean;
};
const InAnySegmentsConfiguration: React.FC<Props> = (props) => {
  const { audienceConfigurationUpdate, availableSegments, editMode, fieldDisabled, segments } =
    props;

  const availableSegmentsData = availableSegments
    ? availableSegments.map<AutocompleteOption>((availableSegment) => ({
        value: availableSegment.id,
        label: availableSegment.name,
      }))
    : [];

  const selectedSegments =
    availableSegmentsData &&
    availableSegmentsData.filter((availableSegment) => segments.includes(availableSegment.value));

  const handleChange = (event: React.ChangeEvent<{}>, selectOptions: AutocompleteOption[]) => {
    audienceConfigurationUpdate(
      'inAnySegments',
      'segments',
      selectOptions.map((selectOption) => selectOption.value),
    );
  };

  const SegmentsSelect = editMode
    ? withAutocompleteValueValidation<AutocompleteProps, InAnySegmentsValidateWith>(
        Autocomplete,
        autocompleteLengthValidation,
      )
    : Autocomplete;

  const renderInput = (
    params: AutocompleteRenderInputParams,
    inputProps?: FormInputProps,
  ): React.ReactNode => (
    <FormInput
      {...params}
      label='In Any Segments Constraint'
      placeholder='Select Segment(s)'
      {...(inputProps || {})}
    />
  );

  return (
    <SegmentsSelect
      multiple={true}
      onChange={handleChange}
      options={availableSegmentsData}
      value={selectedSegments}
      disabled={fieldDisabled('segments')}
      renderInput={renderInput}
    />
  );
};

export { InAnySegmentsConfiguration };
